import { render, staticRenderFns } from "./recherche.vue?vue&type=template&id=2f595a1a"
import script from "./recherche.vue?vue&type=script&lang=js"
export * from "./recherche.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports